import React from 'react';
import styles from './styles.module.scss';

function ProjectCard(props) {
	return (
		<div className={styles.projectGridItem}>
			<div className={styles.flipCardFront}>
				<img
					src={require('../../assets/Projects/' + props.img + '.jpeg')}
					alt='projectimg'
					className={styles.projectImg}
				></img>
			</div>

			<div className={styles.flipCardBack}>
				<p className={styles.projectType}> {props.type}</p>
				<p className={styles.projectTitle}> {props.title}</p>
				<p className={styles.projectDesc}> {props.description}</p>
				{props.button ? (
					<a
						className='project-src-code'
						href={props.link}
						rel='noopener noreferrer'
						target='_blank'
					>
						{props.button}
					</a>
				) : null}
			</div>
		</div>
	);
}

export default ProjectCard;
